// Shared by the Home page FAQ section and the FAQPage structured data (src/seo.js).
export const FAQS = [
  {
    q: 'What is rope access and why use it instead of scaffolding?',
    a: 'Rope access is a work-at-height method where trained technicians reach a building or structure using two independently anchored ropes. It needs no scaffolding or swing stage, so setup is faster, disruption to occupants is lower and costs are often reduced.',
  },
  {
    q: 'Is rope access safe?',
    a: 'Yes, when carried out by trained and certified technicians following strict procedures. ProClimb Solutions works with IRATA Level 3 certified technicians, risk assessments and a safety-first approach on every job.',
  },
  {
    q: 'Which areas do you service?',
    a: 'We are based in Eastlakes, Sydney, and work across Sydney and New South Wales for strata, commercial, industrial and construction clients, as well as high-end private residences.',
  },
  {
    q: 'Do you offer emergency rope access?',
    a: 'Yes. We provide emergency response for loose panels, storm damage, urgent leaks and façade make-safe works. Call 0426 920 301 for a rapid response.',
  },
  {
    q: 'What services can you carry out at height?',
    a: 'High-rise window and façade cleaning, remedial work and sealing, glazing and panel installation, height safety systems installation and inspection, bird control and emergency works.',
  },
  {
    q: 'How do I get a quote?',
    a: 'Use the quote form on our contact page or call 0426 920 301. Tell us about your building and the work required and we will get back to you within 24 hours with a clear, tailored quote.',
  },
];
